// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusSquareFilledSvg from "@fishx/icons-svg/es/asn/MinusSquareFilled";
import FishxIcon from '../components/FishxIcon';

var MinusSquareFilled = function MinusSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareFilledSvg
  }));
};

MinusSquareFilled.displayName = 'MinusSquareFilled';
export default React.forwardRef(MinusSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MinusSquareFilled.js
// module id = 3139
// module chunks = 0